// import memberManage from './memberManage/config/routes'; //会员管理
import staffManage from './staffManage/config/routes' //店员管理
import cancellation from './cancellation/config/routes' //订单作废
import invoice from './invoice/config/routes' //门店开支
import repairAudit from './repairAudit/config/routes' //修护审核
import repairRecord from './repairRecord/config/routes' //修护记录
import orderRefund from './orderRefund/config/routes' // 门店退款
import shopRecharge from './shopRecharge/config/routes' //修护审核
import companyLeave from './companyLeave/config/routes' // 请假记录
import companyRecode from './companyRecode/config/routes' // 离职记录
import shopGift from './shopGift/config/routes' // 赠送记录
import staffTransfer from './staffTransfer/config/routes' // 调店审核
import integralOrder from './integralOrder/config/routes' // 积分兑换
import fundtransfer from './fundtransfer/config/routes' // 资金上缴
import thirdOrder from './thirdOrder/config/routes' // 资金上缴
// import shopServe from './shopServe/config/routes' // 门店服务
// paymentRecords

export default [
	...staffManage,
	...cancellation,
	...invoice,
	...shopRecharge,
	...repairAudit,
	...repairRecord,
	...orderRefund,
	...companyLeave,
	...shopGift,
	...staffTransfer,
	...integralOrder,
	...fundtransfer,
  ...thirdOrder,
  ...companyRecode,
  // ...shopServe
]
